import React, { useState, useEffect } from "react";
import stickers from "../../assets/images/stuff/stickers.png";
import continueImg from "../../assets/images/stuff/continue.png";
import close from "../../assets/images/stuff/close.png";
import telegram from "../../assets/images/socials/telegram.png";
import viber from "../../assets/images/socials/viber.png";
import whatsapp from "../../assets/images/socials/whatsapp.png";
import style from "./Dialog.module.css";
import allContent from "../../allContent";

const Dialog = ({ setShowDialog, dialogContent }) => {
  const [opacity, setOpacity] = useState(0);
  const [scale, setScale] = useState(0.5);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
      setScale(1);
    }, 100);
  }, []);

  const handleClose = () => {
    setOpacity(0);
    setScale(0.5);
    setTimeout(() => {
      setShowDialog(false);
    }, 500);
  };
  return (
    <div className={style.dialog} style={{ opacity: opacity }}>
      <div
        className={style.dialogContainer}
        style={{ transform: `scale(${scale}) ` }}
      >
        {dialogContent.type === "sticker" && (
          <>
            <div className={style.stickers}>
              {" "}
              {/* {dialogContent.stickers.map((sticker, index) => ( */}
              <img
                src={dialogContent.stickers}
                alt="dialog"
                className={style.dialogImg}
              />
              {/* ))}{" "} */}
            </div>
            <h1>
              {allContent.collectWindow.titlesMobile.firstPart
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {/* <br /> */}
                  </React.Fragment>
                ))}{" "}
              {dialogContent.week?.split(" ")[1]}{" "}
              {allContent.collectWindow.titlesMobile.secondPart}
            </h1>
            <br />
            <p>
              {allContent.collectWindow.description
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
            <br />
            <img
              src={continueImg}
              alt="continue"
              className={style.close}
              onPointerDown={handleClose}
            />
          </>
        )}
        {dialogContent.type === "meme" && (
          <>
            <img
              src={dialogContent.meme}
              className={style.dialogVideo}
              loop
              alt="meme"
            />
            <img
              src={close}
              alt="gif media"
              className={style.dialogImg}
              onPointerDown={handleClose}
            />
          </>
        )}
        {dialogContent.type === "download" && (
          <div className={style.socials}>
            <a
              href="https://stickers.viber.com/pages/custom-sticker-packs/11edf62441a44af28b25337fd1ef4eda613f115d7afc38de"
              target="_blank"
            >
              {" "}
              <div className={style.socialsWrapper}>
                <button>
                  <img src={viber} alt="viber" />
                  Viber
                </button>
              </div>{" "}
            </a>{" "}
            <a href="https://t.me/addstickers/retail_heroes" target="_blank">
              <div className={style.socialsWrapper}>
                <button>
                  <img src={telegram} alt="telegram" />
                  Telegram
                </button>
              </div>
            </a>
            <a href="https://sticker.ly/s/WXIARD" target="_blank">
              <div className={style.socialsWrapper}>
                <button>
                  <img src={whatsapp} alt="whatsapp" />
                  WhatsApp
                </button>
              </div>
            </a>
            <img
              src={continueImg}
              alt="continue"
              className={style.close}
              onPointerDown={handleClose}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dialog;
